'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CurrencyConversionsRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = function transform() {
    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return {
        data: {
            conversions: response.payload
        },
        error: response.error
    };
};

var CurrencyConversionsRemote = exports.CurrencyConversionsRemote = {
    fetchCurrencyConversions: function fetchCurrencyConversions(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<CURRENCY-API>' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({
                    err: err,
                    reject: reject,
                    resolve: resolve,
                    response: response,
                    transform: transform
                });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/currencyConversions.js
// module id = IYBZ
// module chunks = 60